// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j5Gq82HOigOWUS {
  display: flex;
  position: fixed;
  z-index: 1;
  right: 0px;
  left: 0px;
  align-items: flex-end;
  justify-content: center;
  height: 0;
  gap: var(--ds-space-100, 8px);
  pointer-events: none;
}
.Lu5xaNCTMO0G0X {
  display: flex;
  padding: 6px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 12px;
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  gap: 6px;
  pointer-events: auto;
}
html[data-color-mode='dark'] .Lu5xaNCTMO0G0X {
  background-color: var(--ds-surface-sunken, #f7f8f9);
}
.HbY71NSj3oJl5e .Lu5xaNCTMO0G0X {
  flex: 1;
  padding: 14px 8px;
  border-radius: 0;
  box-shadow: none;
}
.HbY71NSj3oJl5e .Lu5xaNCTMO0G0X > div {
  flex: 2 0;
}
@media print {
  .j5Gq82HOigOWUS {
    display: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"islandNav": `j5Gq82HOigOWUS`,
	"buttonGroup": `Lu5xaNCTMO0G0X`,
	"fullWidth": `HbY71NSj3oJl5e`
};
export default ___CSS_LOADER_EXPORT___;
